<template>
    <vue-simple-suggest
        ref="geopicker"
        :min-length="3"
        display-attribute="label"
        v-bind="$attrs"
        value-attribute="key"
        :value="inputValue"
        :list="search"
        :debounce="300"
        :styles="autoCompleteStyle"
        @input="$emit('input', $event)"
        @select="select"
        @show-list="onShow"
    >
        <div
            slot="misc-item-below"
            v-if="isLoading && isOnlineBook"
            class="misc-item"
        >
            <span>Loading...</span>
        </div>
    </vue-simple-suggest>
</template>
<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import { isObject, some, get, forEach } from "lodash";

export default {
    name: "VetAddressPicker",
    components: { VueSimpleSuggest },
    props: {
        value: {
            type: [String],
            default: null
        },
        module: {
            type: [String],
            default: "address",
            required: true
        },
        placement: {
            type: String,
            default: "bottom-start"
        }
    },
    data() {
        return {
            selected: false,
            isLoading: false,
            sortOptions: [],
            prevSearch: ""
        };
    },
    computed: {
        inputValue() {
            return this.value;
        },
        autoCompleteStyle() {
            return {
                vueSimpleSuggest: "vue-simple-suggest",
                suggestItem: "suggest-item-vetter",
                defaultInput: this.isOnlineBook ? null : "form-control"
            };
        },
        isOnlineBook() {
            return !this.$http;
        }
    },
    mounted() {},
    methods: {
        onShow() {
            this.$nextTick(() => {
                const addressInputElement = this.$refs.geopicker.inputElement;
                const suggestionElement =
                    this.$refs.geopicker.$el.querySelector(".suggestions");

                if (addressInputElement && suggestionElement) {
                    const addressInputHeight =
                        addressInputElement.getBoundingClientRect().height +
                        parseFloat(
                            window.getComputedStyle(addressInputElement)
                                .marginTop
                        ) +
                        parseFloat(
                            window.getComputedStyle(addressInputElement)
                                .marginBottom
                        );

                    if (addressInputHeight) {
                        // NOTE: add 3px to add some space between address input and suggestion box
                        suggestionElement.style.top =
                            addressInputHeight + 3 + "px";
                    }
                }
            });
        },
        select(params) {
            if (some(params.value)) {
                this.$emit("address-picked", params.value);
                this.$root.$emit("addressPicked", params.value);
                this.$nextTick(() => {
                    if (
                        this.$refs &&
                        this.$refs.geopicker &&
                        module !== "all"
                    ) {
                        this.$refs.geopicker.setText(params.value[this.module]);
                        this.$refs.geopicker.clearSuggestions();
                        this.prevSearch = params.value[this.module];
                        this.selected = true;
                    }
                });
            }
        },
        search(params) {
            let self = this;
            self.isLoading = true;

            if (params != this.prevSearch) {
                this.selected = false;
            }

            if (!isObject(params) && params.length > 3) {
                return self
                    .searchAddress(params)
                    .then(result => {
                        self.sortOptions = [];

                        if (result) {
                            let addressObj = [];
                            addressObj = get(
                                result,
                                "data.response.resource",
                                []
                            );
                            forEach(addressObj, (element, key) => {
                                self.sortOptions[key] = {
                                    value: element,
                                    label: element.label,
                                    key: key
                                };
                            });
                            self.isLoading = false;
                            if (!this.selected) {
                                return self.sortOptions;
                            }
                        }
                    })
                    .finally(() => {
                        this.selected = false;
                    });
            }
        },
        async searchAddress(query) {
            return await (this.$http || this.axios).post(
                (this.isOnlineBook ? "../" : process.env.BARRAMUNDI) +
                    "account/search/address",
                {
                    address: query
                }
            );
        }
    }
};
</script>
<style lang="scss">
.vue-simple-suggest.designed {
    ul.suggestions {
        top: 0;
        border: solid #d4d4d4 1px;
        padding: 0.3rem 0;
        margin: 0 0;
        border-radius: 0.5rem;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
        .suggest-item-vetter {
            &.hover,
            &.selected {
                background-color: #0097cf !important;
            }
        }
        .suggest-item,
        .suggest-item {
            padding: 0.075rem 0.75rem;
        }

        width: max-content;
        min-width: 100%;
    }

    color: #495057;
    .input-wrapper input {
        color: #495057;
    }
}
#address ul.suggestions {
    max-width: 28rem;
    min-width: 100%;

    right: 0px;
    left: initial;
}
</style>
